import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../settings';

export type SquareSize = 'small' | 'medium' | 'large' | 'extra-large';

export interface SquarePosition {
    x: number;
    y: number;
}

interface Props {
    size: SquareSize;
    position: SquarePosition;
    rotation: number;
    fixedHeight?: number;
}

const StyledConfettiBackgroundSquare = styled.div`
    position: absolute;
    z-index: 1;
`;

export default function ConfettiBackgroundSquare({
    size,
    position,
    rotation = 0,
    fixedHeight,
}: Props) {
    return (
        <StyledConfettiBackgroundSquare
            style={styleFromProps({ size, position, rotation, fixedHeight })}
            data-testid={'confetti-background-square'}
        />
    );
}

function styleFromProps({ size, position, rotation, fixedHeight }: Props): any {
    return {
        width: squareSizeToPx(size),
        height: squareSizeToPx(size),
        backgroundColor: colors.grey100,
        top: fixedHeight ? `calc(${(position.y / 100) * fixedHeight}px)` : `${position.y}%`,
        left: `${position.x}%`,
        transform: rotationAsTransformValue(rotation),
    };
}

function squareSizeToPx(size: SquareSize) {
    return {
        small: '8px',
        medium: '10px',
        large: '14px',
        'extra-large': '21px',
    }[size];
}

function rotationAsTransformValue(rotation: number): string {
    return `rotateZ(${rotation}deg)`;
}
